import React, { Component } from 'react';
import Swal from 'sweetalert2';
import Select from 'react-select';
import axios from "axios";
import PageTitle from '../../../Components/PageTitle';
import { ConfigContext } from '../../../Context/ConfigContext';
import { formatDate, SubmitButton, TextBox } from '../../../Components/InputElements';
import { currentDateAndTime,decodeData, getFirstDateBeforeTwoMonths, getFullYearMonthArray, getPreviousDate, monthData, getMonthCycleStartDate, getNextMonthIfDayExceeds20, getDateBeforeToday, getDateAfterToday, getTotalDaysBetweenDates } from '../../../Constants/constants';
import DateRangePicker from '../../../Components/DateRangePicker';
import { NoRecords } from '../../../Components/Shimmer';
import * as XLSX from 'xlsx'


class MyLeavesSandBox extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);
        this.state = {
            employee_leave_id: '',
            leave_type_id: '',
            filter_leave_type_id: '',
            leave_category_id: '',
            employee_leave_from_date: '',
            from_date: '',
            to_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            required_document: 0,
            emp_can_apply_back_dated_leave:0,
            emp_can_apply_back_dated_leave_days:1,
            employee_leave_from_date_to_days:1,
            employee_leave_from_date_to_days:1,
            future_leave_days: 1,
            leave_loader: false,
            employee_leave_status: '',
            fileName: "",
            fileSize: "",
            past_days: 0,
            half_day: 0,
            selectedImage: null,
            loadingList: false,
            loadingLeave: false,
            loadingFilter: false,
            postLoading: false,
            leave_balance_insufficient: false,
            required_comment: false,
            future_days: 1,
            leave_type_row: [],
            leave_type_condition_rows: [],
            leave_type_info: [],
            leave_log_rows: [],
            weekenddays: [],
            festivals: [],
            month: null,
            startDay: null,
            monthOptions: [],
            errors: {},
            errorMessage: '',
            check_modal_type: '',
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            LeaveRows: [],
            get_url: '',
            total_records: 0,
            total_pages: 0,
            rows: [],
            employee_info: [],
            salaries: [],
            salaries_statutory: [],
            successMsg: false,
            errorMsg: false,
            from_unit_row: [],
            to_unit_row: [],
            dateArray: [
                '2024-08-10',
                '2024-08-15',
                '2024-08-20', // Dates in YYYY-MM-DD format
            ],
            leavesBalance: [],
            year: "",
            yearsOptions: [],
            leaveType: "",
            yearlyReport: false,
            decodedData: [],
            is_rm: false,
            enable_apply_button: false,
            applying_for: "1",
            team_employee_id: false,
            teamEmployeesList: [],
            leaveModal: false,
        };
        this.modalRef = React.createRef();
        this.closeRef = React.createRef();
    }

    // componentDidMount() {
    //     this.setState({ loadingList: true }, () => {
    //         this.GetList();
    //         this.GetLeaveTypeList(0);
    //         this.GetRemmainingLeaves();
    //         this.GetAssignShift();

    //     });
    //     let date = currentDateAndTime();
    //     let monthOpt = getFullYearMonthArray(date);
    //     this.setState({ monthOptions: monthOpt });
    // }

    async componentDidMount() {
        this.setState({ loadingList: true }, async () => {
            try {
                await this.GetLeaveTypeList(0);
                await this.GetRemmainingLeaves();
                await this.GetAssignShift();
                await this.GetMonthFilterList();
                let date= getMonthCycleStartDate(currentDateAndTime(),this.state.startDay);
                let currMonth= getNextMonthIfDayExceeds20(date);
                // console.log("componentDidMount ~ currMonth",currMonth);
                this.setState({ month:currMonth}, () =>{
                 this.GetList();
                });
               
                await this.getEmployeeYears();
            } catch (error) {
                console.error('An error occurred in component mounnting:', error);
            } finally {

                this.setState({ loadingList: false });
            }
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                // console.log("encodedData",encodedData);
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                // console.log("decodedData",decodedData);
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
                }
            } else {
                console.warn("Permissions not yet available. Retrying...");
            }
        }
    }

    GetMonthFilterList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetMonthYearFilterList`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                if (data?.success === true) {
                    this.setState({
                        loadingList: false,
                        monthOptions: data?.filterArray

                    });
                    let filterArray = data?.filterArray;
                    // Extract current month from your logic
                    const currentMonth = parseInt(this.getCurrentMonth(), 10);

                    // Find the corresponding month option based on the current month
                    const defaultMonthOption = filterArray.find(option => parseInt(option.value.split("-")[0]) === currentMonth);

                    // Set the month in the state after monthOptions are updated
                    this.setState({
                        month: defaultMonthOption ? defaultMonthOption.value : null, // Set the default month if found
                        startDay: data?.month_cycle_start_date,
                    });

                } else {
                    this.setState({ loadingList: false });
                }
            });
    };

    validateNotEmpty = (fieldName, value) => {
        if (fieldName === "Reason") {
            if (this.state.required_comment === "1" && !value) {
                return `${fieldName} is required`;
            }
            // if (typeof value !== 'string') {
            //     value = String(value);
            // }
            // if (value.trim() === '') {
            //     return `${fieldName} is required`;
            // }
        }
        else {
            if (this.state.required_comment === "1" && !value) {
                return `${fieldName} is required`;
            }
            // if (typeof value !== 'string') {
            //     value = String(value);
            // }
            // if (value.trim() === '') {
            //     return `${fieldName} is required`;
            // }
        }

        return '';
    }

    CheckSelectWeekend = (FromDate, ToDate) => {
        const weekenddays = this.state.weekenddays;

        const fromDate = new Date(FromDate);
        const toDate = new Date(ToDate);

        const dayOfWeekMap = {
            0: "Sunday",
            1: "Monday",
            2: "Tuesday",
            3: "Wednesday",
            4: "Thursday",
            5: "Friday",
            6: "Saturday"
        };

        const isWeekendDay = (date) => {
            const dayOfWeek = dayOfWeekMap[date.getUTCDay()];
            return weekenddays.some(weekend => weekend.shift_day === dayOfWeek);
        };

        if (isWeekendDay(fromDate) && isWeekendDay(toDate)) {
            Swal.fire({
                title: 'Error',
                text: 'You cannot apply leave on your week off',
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
            });
            return true;
        }


        return false;
    };

    CheckSelectFestival = (FromDate, ToDate) => {
        const festivals = this.state.festivals;

        const fromDate = new Date(FromDate);
        const toDate = new Date(ToDate);

        const isFestivalDay = (date) => {
            const formattedDate = date.toISOString().split('T')[0];
            return festivals.some(festival => festival.calendar_festival_date === formattedDate);
        };

        if (isFestivalDay(fromDate) || isFestivalDay(toDate)) {
            // Swal.fire({
            //     title: 'Error',
            //     text: 'You can not apply leave on holiday',
            //     icon: 'error',
            //     confirmButtonText: 'OK'
            // });
            return true;
        }

        return false;
    };

    validateDate = (fieldName, value_to, value_from) => {
        const date = new Date(value_to);
        const today = new Date(value_from);
        if (date < today) {
            return `Please Select Future Date In ${fieldName}....!!`;
        }
        return '';
    }
    // GetLeaveTypeList = (typelist) => {
    //     const { apiURL, apiHeaderJSON } = this.context;
    //     const headers = apiHeaderJSON;
    //     axios.get(`${apiURL}Home/GetLeaveTypeList`, { params: { typelist: typelist }, headers })
    //         .then((response) => {

    //             var data = response.data;
    //             if (response.data.success === true) {
    //                 if (typelist === 0) {
    //                     this.setState((prevState) => ({
    //                         leave_type_row: data.data.map((row) => ({
    //                             value: row.leave_type_id,
    //                             label: row.leave_type_name
    //                         }))
    //                     }));
    //                 } else {
    //                     this.setState((prevState) => ({
    //                         leave_type_condition_rows: data.data.map((row) => ({
    //                             value: row.leave_type_id,
    //                             label: row.leave_name
    //                         }))
    //                     }));
    //                 }
    //             }
    //         });
    // }
    GetLeaveTypeList = (typelist, team_employee_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        axios.get(`${apiURL}Home/GetLeaveTypeListSandbox`, { params: { date: date, typelist: typelist, is_employee:true, team_employee_id: team_employee_id || null }, headers })
            .then((response) => {

                var data = response.data;
                if (response.data.success === true) {
                    // console.log("GetLeaveTypeListSandbox ~ data?.data", data?.data);
                    if (typelist === 0) {
                        this.setState((prevState) => ({
                            leave_type_row: data?.data.map((row) => ({
                            value: row.leave_type_id,
                            label: team_employee_id && row?.leave_type_name && row?.leave_hide=="0" ? `${row?.leave_type_name} (${row?.remaining_leaves})` : row?.leave_type_name || "--",
                            })),
                            leave_type_info: this.state.is_rm ? data?.data : this.state.leave_type_info,
                        }));
                    } else {
                        this.setState((prevState) => ({
                            leave_type_row: this.state.is_rm ? data?.data.map((row) => ({
                                value: row.leave_type_id,
                                label: team_employee_id && row?.leave_name && row?.leave_hide=="0" ? `${row?.leave_name} (${row?.remaining_leaves})` : row?.leave_name || "--",
                                })) : this.state.leave_type_row,
                            leave_type_info: data?.data,
                            leave_type_condition_rows: data?.data.map((row) => ({
                                value: row.leave_type_id,
                                label: row.leave_name
                            }, () =>{
                                // console.log("leave_type_condition_rows ~ row", this.state.leave_type_condition_rows);
                            }))
                        }));
                    }
                }
            });
    }

    // GetLeaveTypeInfo = (leave_type_id) => {
    //     const { apiURL, apiHeaderJSON } = this.context;
    //     const headers = apiHeaderJSON;
    //     axios.get(`${apiURL}Home/GetLeaveTypeInfo`, { params: { leave_type_id: leave_type_id }, headers }).then((response) => {
    //         var data = response.data.data;
    //         if (response.data.success === true) {
    //             this.setState({
    //                 required_document: data[0].required_document,
    //                 half_day: data[0].half_day,
    //                 future_days: data[0].future_days,
    //                 past_days: data[0].past_days,
    //                 loadingList: false,
    //             });
    //         } else {
    //             this.setState({ loadingList: false });
    //         }
    //     });
    // }
    GetLeaveTypeInfo = (leave_type_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetLeaveTypeInfoSandBox`, { params: { leave_type_id: leave_type_id }, headers }).then((response) => {
            var data = response?.data?.data;
            // console.log("response.data.leaveData[0]", data);
            if (response.data.success === true) {
                // console.log("getPreviousDate(this.state.emp_can_apply_back_dated_leave_days)",getPreviousDate(this.state.emp_can_apply_back_dated_leave_days));
                this.setState({
                    leave_type_id: leave_type_id,
                    emp_can_apply_back_dated_leave: data?.emp_can_apply_back_dated_leave,
                    emp_can_apply_back_dated_leave_days: data?.emp_can_apply_back_dated_leave_days,
                    future_leave_days: data?.future_leave_days,
                    required_document: data?.doc_required,
                    required_comment: data?.comment_required,
                    from_unit_row: data?.FromUnit?.map((row) => ({
                        value: row,
                        label: row
                    })),
                    to_unit_row: data?.ToUnit?.map((row) => ({
                        value: row,
                        label: row
                    })),
                    loadingList: false,
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetAssignShift = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetAssignShiftSandBox`, { headers }).then((response) => {
            var data = response.data.data;
            var festivals = response.data.festivals;
            if (response.data.success === true) {
                this.setState({
                    weekenddays: data,
                    festivals: festivals,
                    loadingList: false,
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    // GetList = () => {
    //     const { apiURL, apiHeaderJSON } = this.context;
    //     const headers = apiHeaderJSON;
    //     axios.get(`${apiURL}Home/GetApplyLeaves`, {
    //         params:
    //         {
    //             employee_leave_status: this.state.employee_leave_status,
    //             leave_type_id: this.state.filter_leave_type_id,
    //             from_date: this.state.from_date,
    //             to_date: this.state.to_date,
    //         }, headers
    //     }).then((response) => {
    //         var data = response.data;
    //         if (response.data.success === true) {
    //             this.setState({
    //                 rows: data.data,
    //                 next: data.next,
    //                 prev: data.prev,
    //                 page: data.page,
    //                 total_records: data.total_records,
    //                 total_pages: data.total_pages,
    //                 loadingLeave: false,
    //             });
    //         } else {
    //             this.setState({ loadingLeave: false });
    //         }
    //     });
    // }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetApplyLeavesSandbox`, {
            params:
            {
                limit: this.state.limit,
                page: this.state.page,
                employee_leave_status: this.state.employee_leave_status,
                leave_type_id: this.state.filter_leave_type_id,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                month: this.state.month,
                date: currentDateAndTime(),
            }, headers
        }).then((response) => {
            const data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data || [],
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                });
            }
            this.setState({ loadingLeave: false, loadingFilter: false });
        })
        .catch((error)=>{
            this.setState({ loadingLeave: false, loadingFilter: false });
            Swal.fire({ 
            title: `<strong>Failed</strong>`, 
            text: error?.message, 
            icon: 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
            });
        });
    }
    getYearlyList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        axios.get(`${apiURL}Home/GetLeaveBalanceReport`, {
            params: {
                employee_id: localStorage.getItem("employee_id_emp"),
                year: this.state?.year,
                leave_type_id: this.state?.leaveType,
                date: date,
                is_employee:1,
            },
            headers,
        })
            .then((response) => {
                var data = response.data;
                // console.log("getList ~ data", data);
                if (response.data.success === true) {
                    this.setState({ leavesBalance: data?.data || []});
                    // setPagination({
                    //     ...pagination,
                    //     next: data.next,
                    //     prev: data.prev,
                    //     page: data.page,
                    //     total_records: data.total_records,
                    //     total_pages: data.total_pages,
                    //     loadingList: false,
                    // });
                } else {
                    this.setState({ leavesBalance: [] });
                    // setPagination({
                    //     ...pagination,
                    //     loadingList: false,
                    // });
                }
                this.setState({ loadingFilter: false });
            })
            .catch((error)=>{
                this.setState({ loadingFilter: false });
                Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: error?.message, 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
                });
            });
    };


    getCurrentMonth = () => {
        const currentDate = currentDateAndTime()?.split(" ")[0];
        const currentMonth = currentDate?.split("-")[1];
        return currentMonth;
    };


    handleExcelDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get(`${apiURL}Home/GetApplyLeavesSandbox`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                employee_leave_status: this.state.employee_leave_status,
                leave_type_id: this.state.filter_leave_type_id,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                month: this.state.month,
                date: currentDateAndTime(),
            },
            headers,
        }).then((response) => {
            if (response.data.success === true) {
                const rows = response.data.data;
                const data = rows.map(row => ({
                    'Application Date': formatDate(row?.created_date),
                    'Leave Type': row?.heads_labels[0].concatenated_data,
                    'From Date': formatDate(row?.employee_leave_from_date),
                    'To Date': formatDate(row.employee_leave_to_date),
                    'Before Balance': row?.employee_leave_balance_before,
                    'Duration': row?.employee_leave_days + (row.employee_leave_days <= 1 ? " day" : " days"),
                    'After Balance': row?.employee_leave_balance_after,
                    'Reason': row?.employee_leave_reason,
                    'Status': row?.employee_leave_status_label,
                }));


                const columns = [
                    { header: 'Application Date', key: 'Application Date', width: 15 },
                    { header: 'Leave Type', key: 'Leave Type', width: 20 },
                    { header: 'From Date', key: 'From Date', width: 15 },
                    { header: 'To Date', key: 'To Date', width: 15 },
                    { header: 'Before Balance', key: 'Before Balance', width: 15 },
                    { header: 'Duration', key: 'Duration', width: 10 },
                    { header: 'After Balance', key: 'After Balance', width: 15 },
                    { header: 'Reason', key: 'Reason', width: 30 },
                    { header: 'Status', key: 'Status', width: 20 },
                ];


                const wb = XLSX.utils.book_new();


                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });


                ws['!cols'] = columns.map(column => ({ wch: column.width }));


                XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });


                columns.forEach((column, index) => {
                    ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                });


                XLSX.utils.book_append_sheet(wb, ws, 'My Leaves Report');


                XLSX.writeFile(wb, 'MyLeavesReport.xlsx');


                Swal.close();


                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
            } else {

                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
            }
        })
            .catch((error) => {
                // Close the Swal alert if there is an error
                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
            });
    }
    handleYearlyReportDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        // console.log("handleExcelDownload ==>>", this.state?.selected_employee_id, this.state?.year, this.state?.leaveType, date);
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        axios.get(`${apiURL}Home/GetLeaveBalanceReport`, {
            params: {
                employee_id: localStorage.getItem("employee_id_emp"),
                year: this.state?.year,
                leave_type_id: this.state?.leaveType,
                date: date,
                is_employee: 1,
            },
            headers,
        }).then((response) => {
            if (response.data.success === true) {
                const rows = response?.data?.data;
                const data = rows?.map(row => ({
                    'Employee Name': row?.employee_name || "--",
                    'Employee Code': row?.employee_code || "--",
                    'Leave Type': row?.leave_type_name || "--",
                    'Month': `${monthData[parseInt(row?.month)]}-${row?.year}`,
                    'Opening Balance': row?.opening_balance || '--',
                    'Leaves Accrued': row?.leave_accrued || '--',
                    'Leaves Taken': row?.leave_taken || '--',
                    'Closing Balance': row?.closing_balance || '--',
                }));


                const columns = [
                    { header: 'Employee Name', key: 'Employee Name', width: 20 },
                    { header: 'Employee Code', key: 'Employee Code', width: 14 },
                    { header: 'Leave Type', key: 'Leave Type', width: 12 },
                    { header: 'Month', key: 'Month', width: 10 },
                    { header: 'Opening Balance', key: 'Opening Balance', width: 14 },
                    { header: 'Leaves Accrued', key: 'Leaves Accrued', width: 13 },
                    { header: 'Leaves Taken', key: 'Leaves Taken', width: 12 },
                    { header: 'Closing Balance', key: 'Closing Balance', width: 13 },
                ];



                const wb = XLSX.utils.book_new();


                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });


                ws['!cols'] = columns.map(column => ({ wch: column.width }));


                XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });


                columns.forEach((column, index) => {
                    ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                });


                XLSX.utils.book_append_sheet(wb, ws, 'Team Leaves Balance Report');


                XLSX.writeFile(wb, `${rows[0].employee_name}_LeaveBalanceReport.xlsx`);


                Swal.close();


                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
            } else {

                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
            }
        })
            .catch((error) => {
                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
            });
    }
    getEmployeeYears = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Home/GetYearsList`, { params: { is_employee: 1 }, headers })
            .then((response) => {
                // console.log("getEmployeesYears ~ response", response);
                if (response.data.success === true) {
                    let years_list = response?.data?.data?.map((row) => {
                        return (
                            { value: row, label: row }
                        )
                    });
                    // console.log("years => ", years_list);
                    this.setState({
                        yearsOptions: years_list,
                    });
                } else {
                    this.setState({
                        yearsOptions: [],
                    });
                }
            }).catch((error) => {
                console.error("Error fetching years list:", error);
                this.setState({
                    yearsOptions: [],
                });
            });

    }
    // GetRemmainingLeaves = () => {
    //     const { apiURL, apiHeaderJSON } = this.context;
    //     const headers = apiHeaderJSON;
    //     axios.get(`${apiURL}Home/GetRemainingLeaves`, { headers }).then((response) => {
    //         var data = response.data;

    //         if (response.data.success === true) {
    //             this.setState({
    //                 LeaveRows: data.data,
    //                 loadingList: false
    //             });
    //         } else {
    //             this.setState({ loadingList: false });
    //         }
    //     });
    // }
    GetRemmainingLeaves = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        axios.get(`${apiURL}Home/GetRemainingLeavesSandbox`, { params: { date: date }, headers }).then((response) => {
            var data = response.data;

            if (response.data.success === true) {
                if(data?.is_rm){
                    this.GetTeamEmployeesList();
                }
                this.setState({
                    is_rm: data?.is_rm || false,
                    enable_apply_button: data?.enable_apply_button || false,
                    LeaveRows: data.data || [],
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

      GetTeamEmployeesList = () => {
            const { apiURL, apiHeaderJSON } = this.context;
            const headers = apiHeaderJSON;
    
            axios.get(`${apiURL}Approver/GetMyTeamEmployees`, {
                params: {
                    limit: 10000,
                    page: 1,
                },
                headers,
            })
                .then((response) => {
                    var data = response.data;
                    if (response.data.success === true) {
                        const temp= data.data?.map((val)=>{
                            return {value: val?.employee_id, label: `${val?.employee_code} ${val?.employee_name}`}
                        })
                        this.setState({
                            teamEmployeesList: temp,
                        });
                    } 
                });
        };

    GetLeaveLogs = (employee_leave_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetLeaveLogsSandBox`, { params: { employee_leave_id: employee_leave_id }, headers }).then((response) => {
            var data = response.data;
            this.setState({ leave_log_rows: [] });
            if (response.data.success === true) {
                this.setState({
                    leave_log_rows: data.data || [],
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleCancelLeave = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        Swal.fire({
            title: 'Cancel Leave Remark..!!',
            input: 'text',
            inputPlaceholder: 'Enter your remark here...',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            cancelButtonText: 'Cancel',
            allowOutsideClick:false,
            preConfirm: (remark) => {
                if (!remark) {
                    Swal.showValidationMessage('Remark cannot be empty');
                }
                return remark;
            }
        }).then((remarkResult) => {
            if (remarkResult.isConfirmed) {
                const remark = remarkResult.value;

                this.setState({ status: true });
                const formData = {
                    employee_leave_id: id,
                    remark: remark,
                };
                axios
                    .post(`${apiURL}Home/CancelApplyLeaveSandBox`, formData, { params: { date: date }, headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false
                        });
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                                this.GetRemmainingLeaves();
                            })
                        }
                    })
                    .catch((error) => {
                        Swal.fire({
                            title: '<strong>Error</strong>',
                            html: error.message,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false
                        });
                    });
            }
        });
    }


    CheckValidation = () => {
        const errors = {};
        const {
            employee_leave_from_date,
            employee_leave_to_date,
            employee_leave_reason,
            leave_type_id,
            employee_leave_from_day_unit,
            employee_leave_to_day_unit,
            half_day,
        } = this.state;
        // errors.employee_leave_from_date = this.validateNotEmpty('From Date', employee_leave_from_date);
        // errors.employee_leave_to_date = this.validateNotEmpty('To Date', employee_leave_to_date) || this.validateDate('To Date', employee_leave_to_date, employee_leave_from_date);
        errors.employee_leave_reason = this.validateNotEmpty('Reason', employee_leave_reason);
        if (this.state.required_document == "1" && !file) { errors.required_document = `Document Is required...!`; }
        errors.leave_type_id = this.validateNotEmpty('Leave Type', leave_type_id);
        errors.employee_leave_from_day_unit = this.validateNotEmpty('From Date Unit', employee_leave_from_day_unit);
        errors.employee_leave_to_day_unit = this.validateNotEmpty('To Date Unit', employee_leave_to_day_unit);
        if(this.state.is_rm && !this.state.applying_for){
            errors.applying_for = "Please Select applying for!"
        }
        if(this.state.is_rm && this.state.applying_for==="2" && !this.state.team_employee_id){
            errors.team_employee_id = "Please Select employee to apply leave!"
        }

        // const weekendError = this.CheckSelectWeekend(employee_leave_from_date, employee_leave_to_date);
        // const festivalError = this.CheckSelectFestival(employee_leave_from_date, employee_leave_to_date);

        // if (weekendError === true || festivalError === true) {
        //     errors.weekendError = "weekendError";
        //     errors.festivalError = "festivalError";
        // }

        // Your validation logic for past and future dates
        const minDate = this.calculateMinDate();
        const maxDate = this.calculateMaxDate();

        // Check validation logic for both "From Date" and "To Date"
        // if (employee_leave_from_date && new Date(employee_leave_from_date) < new Date(minDate)) {
        //     errors.employee_leave_from_date = `This leave type allows to apply till ${formatDate(minDate)}`;
        // }
        // if (employee_leave_to_date && new Date(employee_leave_to_date) > new Date(maxDate)) {
        //     errors.employee_leave_to_date = `This leave type allows to apply till ${formatDate(maxDate)}`;
        // }

        // if (employee_leave_from_date === employee_leave_to_date &&
        //     employee_leave_from_day_unit !== employee_leave_to_day_unit) {
        //     errors.employee_leave_to_day_unit = 'Please select same unit as From Day unit';
        // }

        // if (half_day === 0 && employee_leave_from_day_unit !== "Full Day") {
        //     errors.employee_leave_from_day_unit = 'This leave type does not allow half day, please select full day';
        // }
        // if (half_day === 0 && employee_leave_to_day_unit !== "Full Day") {
        //     errors.employee_leave_to_day_unit = 'This leave type does not allow half day, please select full day';
        // }

        return errors;
    }

    handleSubmit = (isUpdate) => {
        const errors = this.CheckValidation();
        const fileInput = document.getElementById("employee_leave_document");
        const file = fileInput.files[0];

        // if (this.state.required_document == "1" && !file) {
        //     errors.required_document = `Document Is required...!`;
        // }

        this.setState({ errors, leave_loader: true }, () => {
            if (Object.values(errors).every(error => error === '')) {

                // const formData = new FormData();
                // formData.append("leave_type_id", this.state.leave_type_id);
                // formData.append("employee_leave_from_date", this.state.employee_leave_from_date);
                // formData.append("employee_leave_to_date", this.state.employee_leave_to_date);
                // formData.append("employee_leave_reason", this.state.employee_leave_reason);
                // formData.append("employee_leave_to_day_unit", this.state.employee_leave_to_day_unit);
                // formData.append("employee_leave_from_day_unit", this.state.employee_leave_from_day_unit);
                // formData.append("required_document", this.state.required_document);
                let formData = {
                    leave_type_id: this.state.leave_type_id,
                    employee_leave_from_date: this.state.employee_leave_from_date,
                    employee_leave_to_date: this.state.employee_leave_to_date,
                    employee_leave_reason: this.state.employee_leave_reason,
                    employee_leave_to_day_unit: this.state.employee_leave_to_day_unit,
                    employee_leave_from_day_unit: this.state.employee_leave_from_day_unit,
                    // required_document: this.state.required_document,
                    employee_leave_document: file ? file : null,
                    employee_leave_id: isUpdate ? this.state.employee_leave_id : null,
                    team_employee_id: this.state.team_employee_id || null,
                    date: currentDateAndTime(),
                    action_from: "1",
                }
                if (isUpdate === true) {
                    // formData.append("employee_leave_id", this.state.employee_leave_id);
                }
                if (file) {
                    // formData.append("employee_leave_document", file);
                }
                let date = currentDateAndTime();
                var headers = this.context.apiHeaderFile;
                const { apiURL } = this.context;
                // console.log("formData", formData);
                axios.post(`${apiURL}Home/CreateApplyLeaveSandBox`, formData, { params: { date: date, team_employee_id: this.state.team_employee_id || null }, headers })
                    .then((response) => {
                        // console.log("handleSubmit ~ response", response);
                        if (response.data.success === true) {

                            // Swal.fire({
                            //     title: `<strong>${response.data.message}</strong>`,
                            //     icon: `${response.data.success === true ? 'success' : 'failed'}`,
                            // });
                            // this.closeRef.current.click();
                            this.setState({ successMsg: response.data.message,errorMsg: "", leave_loader: false, });
                            this.resetForm();
                            this.GetList();
                            this.GetRemmainingLeaves();
                        } else {
                            // Swal.fire({
                            //     title: `<strong>${response.data.message}</strong>`,
                            //     icon: `warning`,
                            // });
                            this.setState({ successMsg: "", errorMsg: response.data.message, leave_loader: false, });
                        }
                    })
                    .catch((error) => {
                        console.error("Error uploading file:", error);
                        this.setState({ errorMsg: error?.response?.data?.message, leave_loader: false, });
                    });
                return;
            }
            this.setState({ leave_loader: false, });
            console.error("Form submission failed due to errors:", errors);
        });
    };




    resetForm = () => {
        this.setState({
            employee_leave_id: 0,
            leave_type_id: '',
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            fileName: "",
            fileSize: "",
            applying_for: "1",
            team_employee_id: false,
        });
    }

    handleSelectStatus = (selectedOption) => {
        this.setState({ employee_leave_status: selectedOption.value, });
    };
    handleSelectType = (selectedOption) => {
        this.setState({ filter_leave_type_id: selectedOption.value, });
    };



    resetemployee_leave_document = () => {

        const employee_leave_document = document.getElementById("employee_leave_document");
        if (employee_leave_document) {
            employee_leave_document.value = null;
        }

        let randomString = Math.random().toString(36);
        this.setState({
            theInputKey: randomString,
        });
    };



    handleFileChange = (e) => {
        const file = e.target.files[0];
        const { errors } = this.state;
        if (file) {
            const { name, size, type } = file;
            const fileSizeInMB = size / (1024 * 1024);
            errors.required_document = '';
            if (fileSizeInMB > 10) {
                this.setState({
                    errorMessage: "File size exceeds the maximum limit of 10 MB",
                });
                console.error("File size exceeds the maximum limit of 10 MB");
                return;
            }
            let newState = {
                fileName: name,
                fileSize: `${fileSizeInMB.toFixed(2)} MB`,
                letterhead: [file],
                errorMessage: '',
            };

            if (type.startsWith("image/")) {
                newState = {
                    ...newState,
                    selectedImage: URL.createObjectURL(file),
                    fileTypeIcon: "ri-image-fill",
                };
            } else {
                newState = {
                    ...newState,
                    isValidPdfFile: true,
                    fileTypeIcon: "ri-file-pdf-fill",
                };
            }
            this.setState(newState);
            this.setState({ errors });
        }
    };


    GetLeaveInfo = (employee_leave_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Home/GetLeaveInfoSandBox`, { params: { employee_leave_id: employee_leave_id }, headers }).then((response) => {
            const { data, success } = response.data;
            this.setState({ get_url: '' });
            if (success === true) {
                // console.log("GetLeaveInfo", response);
                // console.log("leave_type_condition_rows ", this.state.leave_type_condition_rows);
                // console.log(" data[0].leave_type_id ",  data[0].leave_type_id);
                this.setState(
                    {
                        leave_type_id: data[0].leave_type_id,
                        employee_leave_from_date: data[0].employee_leave_from_date,
                        employee_leave_to_date: data[0].employee_leave_to_date,
                        employee_leave_document: data[0].employee_leave_document,
                        employee_leave_reason: data[0].employee_leave_reason,
                        employee_leave_from_day_unit: data[0].employee_leave_from_day_unit,
                        employee_leave_to_day_unit: data[0].employee_leave_to_day_unit,
                        get_url: data[0].employee_leave_document_url,
                        // futureDays:data[0]?.future_days
                    }
                )
            }
        });
    }

    calculateMinDate() {
        const today = new Date();
        const pastDays = this.state.past_days;
        const pastDate = new Date(today);
        pastDate.setDate(today.getDate() - pastDays);

        const year = pastDate.getFullYear();
        const month = String(pastDate.getMonth() + 1).padStart(2, '0');
        const day = String(pastDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    calculateMaxDate() {
        const today = new Date();
        const futureDays = this.state.future_days;
        const futureDate = new Date(today);
        futureDate.setDate(today.getDate() + futureDays);

        const year = futureDate.getFullYear();
        const month = String(futureDate.getMonth() + 1).padStart(2, '0');
        const day = String(futureDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }




    handleCheckModalType = (CheckModalType, employee_leave_id) => {
        this.setState({ successMsg: false, errorMsg: false, leaveModal: true, postLoading: true });
        // console.log(`Checking CheckModalType ===>> ${CheckModalType}`);
        if (CheckModalType === 0) {
            this.resetForm();
            this.GetLeaveTypeList(1);
            this.setState({
                check_modal_type: CheckModalType,
                get_url: '',
                employee_leave_id: 0,
                errors: {},
            });
        }
        else if (CheckModalType === 1) {

            this.setState({
                check_modal_type: CheckModalType,
                employee_leave_id: employee_leave_id,
                errors: {},
            }, ()=> {
                this.GetLeaveInfo(employee_leave_id);
            });
            
        }
        else if (CheckModalType === 2) {
            this.setState({
                check_modal_type: CheckModalType,
                errors: {},
            });
            this.GetLeaveInfo(employee_leave_id);
            this.GetLeaveLogs(employee_leave_id);
        }
        else if (CheckModalType === 3) {
            this.setState({
                check_modal_type: CheckModalType,
                leave_type_id:"",
                employee_leave_from_date: '',
                employee_leave_to_date: '',
                employee_leave_document: '',
                employee_leave_reason: '',
                employee_leave_to_day_unit: '',
                employee_leave_from_day_unit: '',
                fileName: "",
                fileSize: "",
                errors: {},
            }, ()=> {
                this.GetLeaveTypeList(1,this.state.team_employee_id);
            });
        }
        else if (CheckModalType === 4) {
            this.setState({
                check_modal_type: CheckModalType,
                leave_type_id:"",
                employee_leave_from_date: '',
                employee_leave_to_date: '',
                employee_leave_document: '',
                employee_leave_reason: '',
                employee_leave_to_day_unit: '',
                employee_leave_from_day_unit: '',
                fileName: "",
                fileSize: "",
                errors: {},
            }, ()=> {
                this.GetLeaveTypeList(1);
            });
        }
        this.setState({ postLoading: false });
    }

    handleDeleteImage = () => {
        this.setState({
            selectedImage: null,
            fileName: "",
            fileSize: "",

        });
        this.resetemployee_leave_document();
    };
    handleFilter = () => {
        this.GetList();
    }


    handleInputChange = (e) => {
        const { name, value } = e.target;
        // console.log("handleInputChange ~ value", name, value);
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    // handleDateChange=(e, dateType)=>{
    //     const { name, value } = e.target;
    //     if(dateType==="from" && this.state.employee_leave_from_day_unit==="First Half"){
    //         this.setState((prevState) => ({
    //             [name]: this.state.employee_leave_from_date,
    //             errors: {
    //                 ...prevState.errors,
    //                 [name]: '',
    //             },
    //         }));
    //     }
    //     else{
    //         console.log("name, value",name, value);
    //         this.setState((prevState) => ({
    //             [name]: value,
    //             errors: {
    //                 ...prevState.errors,
    //                 [name]: '',
    //             },
    //         }));
    //     }

    // }
    handleDateChange = (date, name) => {
        // console.log("name, value", name, date);
        if (name === "employee_leave_to_date" && this.state.employee_leave_from_day_unit === "Second Half" && this.state.employee_leave_from_date !== date) {
            let toUnitRow = [{ value: "First Half", label: "First Half" },
            { value: "Second Half", label: "Second Half" },
            { value: "Full Day", label: "Full Day" }];

            toUnitRow = toUnitRow?.filter((row) => {
                if (row?.value !== "Second Half") {
                    return {
                        value: row?.value,
                        label: row?.label
                    }
                }
            });
            this.setState({ 
                to_unit_row: toUnitRow,
                employee_leave_to_day_unit:"",
            });
        }
        else if (name === "employee_leave_to_date" && this.state.employee_leave_from_day_unit === "Second Half" && this.state.employee_leave_from_date === date) {
            let toUnitRow = [{ value: "First Half", label: "First Half" },
            { value: "Second Half", label: "Second Half" },
            { value: "Full Day", label: "Full Day" }];

            toUnitRow = toUnitRow?.filter((row) => {
                if (row?.value === "Second Half") {
                    return {
                        value: row?.value,
                        label: row?.label
                    }
                }
            });
            this.setState({ 
                to_unit_row: toUnitRow,
                employee_leave_to_day_unit:"Second Half",
             });
        }
        else if (name === "employee_leave_to_date" && this.state.employee_leave_from_day_unit === "Full Day" && this.state.employee_leave_from_date === date) {
            let toUnitRow = [{ value: "First Half", label: "First Half" },
            { value: "Second Half", label: "Second Half" },
            { value: "Full Day", label: "Full Day" }];

            toUnitRow = toUnitRow?.filter((row) => {
                if (row?.value === "Full Day") {
                    return {
                        value: row?.value,
                        label: row?.label
                    }
                }
            });
            this.setState({ 
                to_unit_row: toUnitRow ,
                employee_leave_to_day_unit:"Full Day",
            });
        }
        else {
            this.setState({
                to_unit_row: this.state.from_unit_row?.length>1 ?
                 [{ value: "First Half", label: "First Half" },
                { value: "Full Day", label: "Full Day" }] :
                [{ value: "Full Day", label: "Full Day" }]
            });
        }
        // console.log("name",name );
        if(name === "employee_leave_from_date"){
            let futureDate = getDateAfterToday(this.state.future_leave_days || 1);
            let days = getTotalDaysBetweenDates(date, futureDate) + 1;
            // console.log("futureDate days",futureDate, days);
            this.setState({
                employee_leave_from_date_to_days: days
            })
        }

        this.setState((prevState) => ({
            [name]: date,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    }

    handleClearAll = () => {
        try {
            let filterArray = this.state.monthOptions;
            // console.log("filterArray in clear", filterArray);
            // Extract current month from your logic
            const currentMonth = parseInt(this.getCurrentMonth(), 10);

            // Find the corresponding month option based on the current month
            const defaultMonthOption = filterArray.find(option => parseInt(option.value.split("-")[0]) === currentMonth);
            this.setState(
                {
                    rows: [],
                    next: false,
                    prev: false,
                    page: 1,
                    limit: 10,
                    total_records: 0,
                    total_pages: 0,
                    loadingList: false,
                    postLoading: false,
                    from_date: "",
                    to_date: "",
                    selectOption: "",
                    // month: `${parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1])}-${parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[0])}`,
                    // month: parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1]),
                    month: defaultMonthOption ? defaultMonthOption.value : null,
                    leavesBalance: [],
                    leaveType: "",
                    filter_leave_type_id :'',
                    employee_leave_status:'',
                    year: "",
                //   yearsOptions: [],

                },
                () => {
                    this.GetList();
                }
            );
        } catch (error) {
            this.setState({ loadingFilter: false });
        }
    };

    handleSelectValue = (name, selectedOption)=> {

        if(name==="team_employee_id"){
            this.handleCheckModalType(3);

            this.setState((prevState) => ({
                [name]: selectedOption.value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        if(name==="applying_for" && selectedOption.value==="1"){
            this.handleCheckModalType(4);
            
            this.setState((prevState) => ({
                [name]: selectedOption.value,
                team_employee_id: false,
                leave_type_id: false,
            }));
        }
        if(name==="applying_for" && selectedOption.value==="2"){
            this.handleCheckModalType(4);
            
            this.setState((prevState) => ({
                [name]: selectedOption.value,
                team_employee_id: false,
                leave_type_id: false,
                employee_leave_from_date: '',
                employee_leave_to_date: '',
                employee_leave_document: '',
                employee_leave_to_day_unit: '',
                employee_leave_from_day_unit: '',
                selectedImage: null,
                fileName: "",
                fileSize: "",
            }));
        }
        else{
            this.setState((prevState) => ({
                [name]: selectedOption.value,
                
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }

        
    }

    handleSelect = (selectedOption) => {
        const { value, label } = selectedOption;
        let errorMessage = this.validateNotEmpty('Leave Type', value);
        let leave_info = this.state.leave_type_info?.filter((val) => {
            if (value == val?.leave_type_id) {
                return val
            }
        });
        if(leave_info?.length===0){
            Swal.fire({
                title: '<strong>Faild</strong>',
                html: "No data found for this type of leave!",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
            });
            this.setState({
                employee_leave_id: 0,
                employee_leave_from_date: '',
                employee_leave_to_date: '',
                employee_leave_document: '',
                employee_leave_to_day_unit: '',
                employee_leave_from_day_unit: '',
                selectedImage: null,
                fileName: "",
                fileSize: "",
                leave_type_id: "",
                errors: {
                    leave_type_id: ""
                }
            });
            return
        }
        // console.log("leave_info", leave_info, this.state.leave_type_info);
        // console.log("value",value);
        if (leave_info[0]?.insufficient_balance === false) {
           
            this.GetLeaveTypeInfo(value);
            this.setState({
                leave_balance_insufficient: false
            })
        }
        else if (leave_info[0]?.insufficient_balance === true) {
            errorMessage = `You have low Balance for ${label}`
            this.setState({
                leave_balance_insufficient: true
            })
        }
        // console.log("errorMessage", errorMessage);
        this.setState({
            // employee_leave_id: 0,
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            selectedImage: null,
            fileName: "",
            fileSize: "",
            leave_type_id: value,
            errors: {
                leave_type_id: errorMessage
            }
        },
    ()=>{
        // console.log('this.state.leave_balance_insufficient || this.state.check_modal_type || this.state.leave_type_id');
        // console.log(this.state.leave_balance_insufficient, this.state.check_modal_type, this.state.leave_type_id);
    });
    };
    handleSelectChange = (name, selectedOption) => {
        // console.log("handleSelectChange ~ name, selectedOption", name, selectedOption);
        if (name === "employee_leave_from_day_unit" && selectedOption.value === "First Half") {
            this.setState((prevState) => ({
                employee_leave_to_date: this.state.employee_leave_from_date,
                employee_leave_to_day_unit: selectedOption.value,
                [name]: selectedOption.value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else if (name === "employee_leave_from_day_unit" && (this.state.employee_leave_from_date === this.state.employee_leave_to_date) && selectedOption.value === "Full Day") {
            
            this.setState((prevState) => ({
                employee_leave_to_day_unit: "Full Day",
                [name]: selectedOption.value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else if (name === "employee_leave_from_day_unit" && (this.state.employee_leave_from_date === this.state.employee_leave_to_date) && selectedOption.value === "First Half") {
            
            this.setState((prevState) => ({
                employee_leave_to_day_unit: "First Half",
                [name]: selectedOption.value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else if (name === "employee_leave_from_day_unit" && (this.state.employee_leave_from_date === this.state.employee_leave_to_date) && selectedOption.value === "Second Half") {
            
            this.setState((prevState) => ({
                employee_leave_to_day_unit: "Second Half",
                [name]: selectedOption.value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else if (name === "employee_leave_from_day_unit" && this.state.employee_leave_from_day_unit === "First Half" && selectedOption.value === "Second Half") {
            this.setState((prevState) => ({
                employee_leave_to_date: "",
                employee_leave_to_day_unit: "",
                [name]: selectedOption.value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else if (name === "employee_leave_from_day_unit" && (this.state.employee_leave_from_day_unit === "First Half" || this.state.employee_leave_from_day_unit === "Second Half") && selectedOption.value === "Full Day") {
            
            this.setState((prevState) => ({
                employee_leave_to_date: "",
                employee_leave_to_day_unit: "",
                [name]: selectedOption.value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else {
            // console.log("employee_leave_to_day_unit",name, selectedOption.value);
            this.setState((prevState) => ({
                [name]: selectedOption.value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
    };
    handlePrev = (ev) => {
        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {
        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {
        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }
    handleLimitChange = (e) => {
        this.setState(
            {
                limit: parseInt(e.target.value, 10),
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    };

    render() {
        const { errorMessage, leave_log_rows, loadingList, LeaveRows, errors } = this.state;
        const limitOptions = [10, 25, 50, 100, 200, 500];

        const statusOptions = [
            { value: '0', label: 'Pending' },
            { value: '2', label: 'Approved' },
            { value: '1', label: 'Rejected' },
            { value: '3', label: 'Canceled' },
        ];
        const applyForOptions = [
            { value: '1', label: 'Self' },
            { value: '2', label: 'Team' },
        ];

        const UnitOptions = [
            { value: "First Half", label: "First Half" },
            { value: "Second Half", label: "Second Half" },
            { value: "Full Day", label: "Full Day" }
        ];

        return (
            this.state.loadingList === false ?
                (
                    <div class="main-content" >
                        {this.state.postLoading ?
                            <div style={{ "height": "100vh", "width": "100vw", "backgroundColor": "#41414128", "zIndex": 1000 }} className=' top-0 left-0 position-fixed d-flex justify-content-center align-items-center'>
                                <div className="text-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div> : null
                        }
                        <div class="page-content">
                            <div className="container-fluid">
                                <br />
                                <PageTitle title={`My Leaves`} primary={`My details`} />
                                <div className='card'>

                                    <div className='card-body'>
                                        {/* <div class="card-header bg-light bg-gradient">
                                  <h6 className="card-title mb-0 text-center">My Leaves</h6>
                                   </div> */}

                                        {/* <div className='row'>
                                            <div className="col-lg-12"> */}
                                                {/* <div style={{ float: "right" }}> */}
                                                {this.state.leaveModal && (
                                                    <div className="modal show"  style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}>
                                                        <div className={` m-auto mt-3 w-modal`}>
                                                            <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h5 className="modal-title" id="myModalLabel">
                                                                        {this.state.check_modal_type === 0 ? "Apply Leave" :
                                                                            this.state.check_modal_type === 1 ? "Update Leave" : "View Leave Details"}
                                                                    </h5>
                                                                    <button type="button" className="btn-close" onClick={() => { this.setState({ leaveModal: false }); this.resetForm()}}> </button>
                                                                </div>
                                                                <div className="modal-body pt-md-3 pt-0">
                                                                    <form className="row" >
                                                                        {this.state.is_rm && this.state.check_modal_type != 2 && (
                                                                            <div className="col-md-6 mt-md-3">
                                                                                <label htmlFor="applying_for" className="form-label">Appling For:</label>
                                                                                <Select
                                                                                    onChange={(selectedOption)=> this.handleSelectValue("applying_for",selectedOption)}
                                                                                    placeholder={`Select`}
                                                                                    options={applyForOptions}
                                                                                    value={applyForOptions.find(option => option.value == this.state.applying_for) || null}
                                                            
                                                                                />
                                                                                {errors.applying_for && <div className="text-danger">{errors.applying_for}</div>}
                                                                            </div>
                                                                        )}
                                                                        
                                                                        {this.state.applying_for==="2" && (
                                                                            <div className="col-md-6 mt-3">
                                                                                <label htmlFor="team_employee_id" className="form-label">Team Employees List:</label>
                                                                                <Select
                                                                                    onChange={(selectedOption)=> this.handleSelectValue("team_employee_id",selectedOption)}
                                                                                    placeholder={`Select Employee`}
                                                                                    options={this.state.teamEmployeesList}
                                                                                    value={this.state.team_employee_id ? this.state.teamEmployeesList.find(option => option.value == this.state.team_employee_id) : null}
                                                                                />
                                                                                {errors.team_employee_id && <div className="text-danger">{errors.team_employee_id}</div>}
                                                                            </div>
                                                                        )}
                                                                        
                                                                        <div className="col-md-12 mt-md-3">
                                                                            <label htmlFor="leave_type_id" className="form-label">Select Leave Type:</label>
                                                                            {!this.state.leave_type_id && <div>
                                                                                <label htmlFor="leave_type_id" className="form-label"><small className='text-muted'> Please Select Leave Type First For Other Fields</small></label>
                                                                            </div>}
                                                                            <Select
                                                                                onChange={this.handleSelect}
                                                                                placeholder={`Select`}
                                                                                isDisabled={(this.state.applying_for==="2" && !this.state.team_employee_id) || this.state.check_modal_type === 2 }
                                                                                options={this.state.leave_type_row}
                                                                                value={this.state.leave_type_id ? this.state.leave_type_row.find(option => option.value == this.state.leave_type_id) : null}
                                                        
                                                                            />
                                                                            {errors.leave_type_id && <div className="text-danger">{errors.leave_type_id}</div>}
                                                                        </div>

                                                                        <div className="col-md-6 mt-3">
                                                                            <label htmlFor="employee_leave_from_date"><span>From Date</span></label>
                                                                            <DateRangePicker handleDateChange={this.handleDateChange} startDate={this.state.emp_can_apply_back_dated_leave_days ? getDateBeforeToday(this.state.emp_can_apply_back_dated_leave_days) : 0} totalDays={this.state.emp_can_apply_back_dated_leave_days + this.state.future_leave_days}
                                                                                isDisabled={this.state.leave_balance_insufficient || this.state.check_modal_type === 2 || !this.state.leave_type_id || (this.state.applying_for==="2" && !this.state.team_employee_id)}
                                                                                name="employee_leave_from_date"
                                                                                dateArray={this.state.dateArray}
                                                                                value={this.state.employee_leave_from_date} />
                                                                            {/* <input
                                                                                type="date"
                                                                                id="employee_leave_from_date"
                                                                                name="employee_leave_from_date"
                                                                                disabled={this.state.leave_balance_insufficient || this.state.check_modal_type === 2 || !this.state.leave_type_id}
                                                                                value={this.state.employee_leave_from_date}
                                                                                className='form-control'
                                                                                onChange={(e)=>this.handleDateChange(e,'from')}
                                                                            /> */}

                                                                            {errors.employee_leave_from_date && <div className="text-danger">{errors.employee_leave_from_date}</div>}

                                                                        </div>
                                                                        <div className="col-md-6 mt-3">
                                                                            <label htmlFor="employee_leave_from_day_unit" className="form-label">Form Date Unit:</label>
                                                                            <Select
                                                                                id="employee_leave_from_day_unit"
                                                                                name="employee_leave_from_day_unit"
                                                                                value={this.state.employee_leave_from_day_unit ? UnitOptions.find(option => option.value === this.state.employee_leave_from_day_unit) : null}
                                                                                onChange={(selectedOption) => this.handleSelectChange("employee_leave_from_day_unit", selectedOption)}
                                                                                options={this.state.from_unit_row}
                                                                                placeholder="Select from date unit"
                                                                                required
                                                                                isDisabled={!this.state.employee_leave_from_date || this.state.check_modal_type === 2 || !this.state.leave_type_id}
                                                                            />
                                                                            {errors.employee_leave_from_day_unit && <div className="text-danger">{errors.employee_leave_from_day_unit}</div>}
                                                                        </div>

                                                                        <div className="col-md-6 mt-3">
                                                                            <label htmlFor="employee_leave_to_date"><span>To Date</span></label>
                                                                            <DateRangePicker handleDateChange={this.handleDateChange} startDate={this.state?.employee_leave_from_date ? getPreviousDate(this.state?.employee_leave_from_date) : ""} totalDays={this.state.employee_leave_from_date_to_days}
                                                                                isDisabled={!this.state.employee_leave_from_day_unit || this.state.employee_leave_from_day_unit === "First Half" || this.state.check_modal_type === 2 || !this.state.leave_type_id || (this.state.applying_for==="2" && !this.state.team_employee_id)}
                                                                                name="employee_leave_to_date"
                                                                                value={this.state.employee_leave_to_date} />
                                                                            {/* <input
                                                                                type="date"
                                                                                id="employee_leave_to_date" name="employee_leave_to_date"
                                                                                value={this.state.employee_leave_to_date} className='form-control'
                                                                                disabled={!this.state.employee_leave_from_day_unit || this.state.employee_leave_from_day_unit === "First Half" || this.state.check_modal_type === 2 || !this.state.leave_type_id}
                                                                                onChange={(e) => this.handleDateChange(e, 'to')} /> */}
                                                                            {errors.employee_leave_to_date && <div className="text-danger">{errors.employee_leave_to_date}</div>}
                                                                        </div>
                                                                        <div className="col-md-6 mt-3">
                                                                            <label htmlFor="employee_leave_to_day_unit" className="form-label">To Date Unit:</label>
                                                                            <Select
                                                                                id="employee_leave_to_day_unit"
                                                                                name="employee_leave_to_day_unit"
                                                                                value={this.state.employee_leave_to_day_unit ? UnitOptions.find(option => option.value === this.state.employee_leave_to_day_unit) : null}
                                                                                onChange={(selectedOption) => this.handleSelectChange("employee_leave_to_day_unit", selectedOption)}
                                                                                options={this.state.to_unit_row}
                                                                                placeholder="Select to date unit"
                                                                                required
                                                                                isDisabled={!this.state.employee_leave_to_date || this.state.employee_leave_from_day_unit === "First Half" || (this.state.employee_leave_from_date === this.state.employee_leave_to_date) || this.state.check_modal_type === 2 || !this.state.leave_type_id}
                                                                            />
                                                                            {errors.employee_leave_to_day_unit && <div className="text-danger">{errors.employee_leave_to_day_unit}</div>}
                                                                        </div>
                                                                        <div className="col-md-12 mt-3">
                                                                            <label>Reason</label>
                                                                            <textarea type='text' rows={3} className='form-control' id='employee_leave_reason' name='employee_leave_reason' value={this.state.employee_leave_reason} disabled={!this.state.employee_leave_to_day_unit || this.state.check_modal_type === 2 || !this.state.leave_type_id} label='Reason' placeholder='Enter Reason' onChange={this.handleInputChange} />
                                                                            {errors.employee_leave_reason && <div className="text-danger">{errors.employee_leave_reason}</div>}
                                                                        </div>
                                                                        {this.state.successMsg ?
                                                                            <div className=" position-relative alert alert-success mt-3" role="alert">
                                                                                {this.state.successMsg} <span onClick={() => { this.setState({ successMsg: false }) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                                            </div>
                                                                            : null
                                                                        }
                                                                        {this.state.errorMsg ?
                                                                            <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                                                {this.state.errorMsg} <span onClick={() => { this.setState({ errorMsg: false }) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                                            </div> : null
                                                                        }
                                                                        <div className="col-md-12 mt-3">
                                                                            <a href={`${this.state.get_url}`}
                                                                                className={`${!this.state.get_url ? ('d-none') : ''} link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                                                                                style={{ marginTop: "10px", float: 'right' }}
                                                                                target="_blank" rel="noopener noreferrer">
                                                                                View Uploaded Document
                                                                            </a>
                                                                        </div>
                                                                        {this.state.check_modal_type !== 2 ? (
                                                                            <div className="col-md-12 mt-3">
                                                                                <label htmlFor="employee_leave_document" className="form-label">Attachment<span className='text-muted '>{this.state.required_document == 0 ? ("(...Optional)") : "(...Required)"}</span></label>
                                                                                <div>
                                                                                    <input
                                                                                        type="file"
                                                                                        id="employee_leave_document"
                                                                                        key={this.state.theInputKey || ""}
                                                                                        onChange={this.handleFileChange}
                                                                                        style={{ marginTop: "10px", display: "none" }}
                                                                                        accept="image/jpeg, image/png, application/pdf"
                                                                                        disabled={this.state.check_modal_type === 2}
                                                                                    />

                                                                                    <div className="d-flex justify-content-between mt-3">
                                                                                        <div>
                                                                                            <label
                                                                                                type="submit"
                                                                                                className="btn btn-primary btn-label waves-effect waves-light"
                                                                                                style={{ marginTop: "10px" }}
                                                                                                htmlFor="employee_leave_document"
                                                                                                disabled={this.state.check_modal_type === 2}
                                                                                            >
                                                                                                <i className="ri-file-line label-icon align-middle fs-16 me-2" />
                                                                                                Choose File
                                                                                            </label>
                                                                                            {errors.required_document && <div className="text-danger">{errors.required_document}</div>}
                                                                                        </div>
                                                                                        <div>
                                                                                            {this.state.leave_loader === false ? (
                                                                                                this.state.check_modal_type === 0 || this.state.check_modal_type === 3 || this.state.check_modal_type === 4 ? (
                                                                                                    <button type="button" className="btn btn-success btn-label waves-effect waves-light" disabled={!this.state.employee_leave_to_day_unit || !this.state.leave_type_id} style={{ marginTop: "10px" }} onClick={() => this.handleSubmit(false)}>
                                                                                                        <i className="ri-user-shared-2-line label-icon align-middle fs-16 me-2" />
                                                                                                        Apply
                                                                                                    </button>

                                                                                                ) : this.state.check_modal_type === 1 ? (
                                                                                                    <button type="button" className="btn btn-success btn-label waves-effect waves-light" style={{ marginTop: "10px" }} onClick={() => this.handleSubmit(true)}>
                                                                                                        <i className="ri-user-shared-2-line label-icon align-middle fs-16 me-2" />
                                                                                                        Update
                                                                                                    </button>
                                                                                                ) : <></>
                                                                                            ) :
                                                                                                <>
                                                                                                    <button type="button" className="btn btn-success disabled" style={{ height: "50px" }}><i className="spinner-grow fs-15" /></button>

                                                                                                </>
                                                                                            }
                                                                                        </div>

                                                                                    </div>

                                                                                    <input
                                                                                        type="file"
                                                                                        id="employee_leave_document"
                                                                                        key={this.state.theInputKey || ""}
                                                                                        onChange={this.handleFileChange}
                                                                                        style={{ marginTop: "10px", display: "none" }}
                                                                                        accept="image/jpeg, image/png, application/pdf"
                                                                                    />
                                                                                    {errorMessage && <div className="text-danger">{errorMessage}</div>}
                                                                                    <ul className="list-unstyled mb-0" id="dropzone-preview"
                                                                                        style={{ display: this.state.fileName === "" ? "none" : "block", }}>
                                                                                        <li className="mt-2 dz-processing dz-error dz-complete"
                                                                                            id="dropzone-preview-list">
                                                                                            <div className="border rounded">
                                                                                                <div className="d-flex p-2">
                                                                                                    <div className="flex-shrink-0 me-3">
                                                                                                        <div className="avatar-sm bg-light rounded">
                                                                                                            <i className={this.state.fileTypeIcon} style={{ position: "absolute", color: "green", marginLeft: "12px", marginTop: "5px", fontSize: "25px" }}></i>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="flex-grow-1">
                                                                                                        <div className="pt-1">
                                                                                                            <h5 className="fs-13 mb-1" data-dz-name=""
                                                                                                            style={{ maxWidth: "10rem", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis",}}>
                                                                                                                {this.state.fileName}
                                                                                                            </h5>
                                                                                                            <p className="fs-13 text-muted mb-0" data-dz-size="">
                                                                                                                <strong>{this.state.fileSize}</strong>
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="flex-shrink-0 ms-3 d-flex justify-content-center align-items-center">
                                                                                                        <button
                                                                                                            type='button'
                                                                                                            data-dz-remove=""
                                                                                                            onClick={this.handleDeleteImage}
                                                                                                            className="btn btn-sm btn-outline-danger"
                                                                                                        >
                                                                                                            <i className="ri-delete-bin-line"></i>
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>) :
                                                                            <div>
                                                                                <div className="my-3">
                                                                                    <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Logs</h5>

                                                                                </div>
                                                                                <div className='table-responsive'>
                                                                                    <table className="table table-nowrap text-center mb-0">

                                                                                        <thead className="table-light">
                                                                                            <tr>
                                                                                                <th>Application Date</th>
                                                                                                <th>Action By</th>
                                                                                                <th>Leave Type</th>
                                                                                                <th>From Date</th>
                                                                                                <th>To Date</th>
                                                                                                <th>Before Balance</th>
                                                                                                <th>Total Leave Days</th>
                                                                                                <th>After Balance</th>
                                                                                                <th>Reason</th>
                                                                                                <th>Remark</th>
                                                                                                <th>Status</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {leave_log_rows.map((row,idx) => {
                                                                                                const leave_obj = JSON.parse(row.leave_apply_object);
                                                                                                return (
                                                                                                    <tr key={row?.employee_leave_log_id || idx}>
                                                                                                        <td>{row?.created_date? formatDate(row.created_date) : "--"}</td>
                                                                                                        <td>{row?.created_by_name || "--"}</td>
                                                                                                        <td>{leave_obj?.leave_type_name || "--"}</td>
                                                                                                        <td>{leave_obj?.employee_leave_from_date? formatDate(leave_obj?.employee_leave_from_date) : "--"}</td>
                                                                                                        <td>{leave_obj?.employee_leave_to_date? formatDate(leave_obj?.employee_leave_to_date) : "--"}</td>
                                                                                                        <td>{leave_obj?.employee_leave_balance_before || "--"}</td>
                                                                                                        <td>{ leave_obj?.employee_leave_days ? `${leave_obj?.employee_leave_days} ${row.employee_leave_days <= 1 ? " day" : " days"}` : "--"}</td>
                                                                                                        <td>{leave_obj?.employee_leave_balance_after || "--"}</td>
                                                                                                        <td className={` ${leave_obj?.employee_leave_reason?.length >= 30 ? "textEllipse" : "noWrap"} text-start`}>{leave_obj?.employee_leave_reason || "--"}</td>
                                                                                                        <td className={` ${row?.remark?.length >= 30 ? "textEllipse" : "noWrap"} text-start`}>{row?.remark}</td>
                                                                                                        <td ><span className={`badge bg-${row?.employee_leave_log_status_class}`}>{row?.employee_leave_status_label}</span></td>
                                                                                                    </tr>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </form>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {/* </div> */}
                                            {/* </div>
                                        </div> */}
                                        <div className="row">
                                            <div className="col-lg-12" >
                                                <div className="card-header p-md-3 p-0 pb-3 d-flex justify-content-between align-items-center gap-2 flex-wrap">
                                                    <h6 className="card-title mb-0">AVAILABLE LEAVES</h6>
                                                    { this.state.decodedData?.includes(2) && ( 
                                                    <button type="button" disabled={!this.state.enable_apply_button} onClick={() => {this.handleCheckModalType(0, 0)}} 
                                                    className="btn btn-success btn-label waves-effect waves-light" >
                                                        <i className="bx bx-add-to-queue label-icon align-middle fs-16 me-2" />
                                                        Apply Leave
                                                    </button>
                                                )}
                                                </div>
                                                <div className=" d-md-block d-none card-body p-md-3 p-0">
                                                    {/* <div style={{ "overflowY": "auto", "overflowX": "none" }}> */}
                                                        <div className="row">
                                                            {loadingList ? (
                                                                <center>Loading...</center>
                                                            ) : (
                                                                LeaveRows?.length===0 ?
                                                                <h5 className=" text-muted">No Leaves Available!</h5>:
                                                                LeaveRows?.map((LeaveRow) => (
                                                                    <div className="col-md-4 mx-md-0 mx-3" key={LeaveRow.leave_type_id}>
                                                                        <div className="card">
                                                                            <div className="card-body">
                                                                                <h2><span className=" text-lg-start text-primary">{LeaveRow.remaining_leaves}</span></h2>
                                                                                <h5 className="card-title text-muted">{LeaveRow.leave_name}</h5>
                                                                                {/* <div className="progress">
                                                                                    <div className="progress-bar" role="progressbar" style={{ width: `${(LeaveRow.remaining_leaves / LeaveRow.total_leaves) * 100}%` }} aria-valuenow={LeaveRow.remaining_leaves} aria-valuemin="0" aria-valuemax={LeaveRow.total_leaves}></div>
                                                                                </div> */}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            )}
                                                        </div>
                                                    {/* </div> */}
                                                </div>
                                                <div className=" d-md-none d-block p-md-3">
                                                    <div style={{ "overflowY": "none", "overflowX": "auto" }}>
                                                        <div className="d-flex align-items-center gap-2 p-2">
                                                            {loadingList ? (
                                                                <center>Loading...</center>
                                                            ) : (
                                                                LeaveRows?.length===0 ?
                                                                <h5 className=" text-muted">No Leaves Available!</h5>:
                                                                LeaveRows?.map((LeaveRow) => (
                                                                    // <div className="" key={LeaveRow.leave_type_id}>
                                                                        <div className="grayBlurShadow bg-white rounded-3" key={LeaveRow.leave_type_id}>
                                                                            <div className=" px-3 py-1">
                                                                                <h4><span className=" text-sm-start mb-0 text-primary">{LeaveRow.remaining_leaves}</span></h4>
                                                                                <h6 className="card-title text-muted noWrap">{LeaveRow.leave_name}</h6>
                                                                                {/* <div className="progress">
                                                                                    <div className="progress-bar" role="progressbar" style={{ width: `${(LeaveRow.remaining_leaves / LeaveRow.total_leaves) * 100}%` }} aria-valuenow={LeaveRow.remaining_leaves} aria-valuemin="0" aria-valuemax={LeaveRow.total_leaves}></div>
                                                                                </div> */}
                                                                            </div>
                                                                        </div>
                                                                    // </div>


                                                                ))
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-lg-6">
                                                <div className="card-header">
                                                    <h6 className="card-title mb-0 text-center" >LEAVE HISTORY</h6>
                                                </div>
                                                <div className="card-body">
                                                    <div data-simplebar style={{ maxHeight: "350px" }}>
                                                        <ul className="list-group p-3">
                                                            {
                                                                this.state.rows.length !== 0 ? (
                                                                    this.state.rows.map(row => (
                                                                        <div className="card mb-3" key={row.employee_leave_id} style={{ borderLeft: `5px solid ${row.employee_leave_status === 0 ? 'rgb(239 174 78)' : row.employee_leave_status === 1 ? 'rgb(247 102 110)' : row.employee_leave_status === 2 ? 'rgb(60 209 136)' : 'rgb(255 127 93)'}` }}>
                                                                            <div className="card-body">
                                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                    <div>
                                                                                        <h6 className="card-title mb-2">{row.heads_labels[0].concatenated_data}</h6>
                                                                                        <small className="card-text text-muted mb-2">{formatDate(row.employee_leave_from_date)} To {formatDate(row.employee_leave_to_date)}</small> <br />
                                                                                        <small className="card-text text-muted mb-0">{row.employee_leave_from_day_unit} - {row.employee_leave_to_day_unit}</small>
                                                                                    </div>

                                                                                    <div className="flex-shrink-0 ">
                                                                                        <span className={`badge badge-label bg-${row.employee_leave_status_class} text-white`}><i className="mdi mdi-circle-medium" /> {row.employee_leave_status_label}</span>

                                                                                    </div>
                                                                                </div>
                                                                                <div className="d-flex justify-content-end align-items-center">
                                                                                    <button className="btn btn-outline-info btn-sm me-2" data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => this.handleCheckModalType(2, row.employee_leave_id)}>
                                                                                        <i className='ri-eye-line' style={{ marginTop: "5px", marginRight: "5px" }} /> View
                                                                                    </button>

                                                                                    {row.employee_leave_status === 0 || (row.employee_leave_status === 2 && new Date(row.employee_leave_from_date) >= new Date()) ? (
                                                                                        <button className="btn btn-outline-danger btn-sm" onClick={() => this.handleCancelLeave(row.employee_leave_id)}>
                                                                                            <i className='ri-close-fill' style={{ marginTop: "5px" }} /> Cancel
                                                                                        </button>
                                                                                    ) : <></>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))) :
                                                                    <>
                                                                        <div class="card shadow-none">
                                                                            <div class="card-body text-center">
                                                                                <div>No Data...!!</div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className='row'>
                                            <div style={{ width: "97%" }} className="m-md-3 mt-md-0 mt-3 d-flex justify-content-between align-items-center flex-wrap">
                                                <h6 className="card-title mb-0" >{!this.state.yearlyReport ? "LEAVE HISTORY" : "YEAR BALANCE REPORT"}</h6>
                                                <button
                                                    type="button"
                                                    onClick={() => { this.setState({ yearlyReport: !this.state.yearlyReport }) }}
                                                    className={` noWrap btn btn-info`}>
                                                    {!this.state.yearlyReport ? "Check Year Balance" : "Check Leave History"}
                                                </button>
                                            </div>
                                            <div className='col-md-12'>
                                                {!this.state.yearlyReport ?
                                                    <div className='row'>
                                                         <div className='col-md-3'>
                                                        <TextBox type="date" id="from_date" name="from_date" label="From Date" value={this.state.from_date} change={this.handleInputChange} />
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <TextBox type="date" id="to_date" name="to_date" label="To Date" value={this.state.to_date} change={this.handleInputChange} />
                                                    </div> 
                                                        {/* <div className='col-md-3'>
                                                            <div className=' position-relative'>
                                                                <div>
                                                                    <label>Month</label>
                                                                </div>
                                                                <div style={{ "zIndex": 11, "width": "100%" }} className=' position-absolute'>
                                                                    <Select
                                                                        options={this.state.monthOptions}
                                                                        value={this.state.month ? this.state.monthOptions.find(option => option.value === this.state.month) : null}
                                                                        onChange={(selectOption) => this.setState({ month: selectOption?.value })}
                                                                        hint={`Select Month`}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        <div className='col-md-2 position-relative mb-5'>
                                                            <div><label>Status</label></div>
                                                            <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                                <Select onChange={this.handleSelectStatus}
                                                                options={statusOptions}
                                                                placeholder={`Select Status`}
                                                                value={this.state.employee_leave_status ? statusOptions.find(option => option.value === this.state.employee_leave_status) : null}/>
                                                             </div>
                                                        </div>
                                                        <div className='col-md-2 position-relative mb-5'>
                                                            <div><label>Leave</label></div>
                                                            <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                                                                <Select onChange={this.handleSelectType}
                                                                options={this.state.leave_type_row}
                                                                placeholder={`Leave Type`}
                                                                value={this.state.filter_leave_type_id ? this.state.leave_type_row.find((option) => option.value === this.state.filter_leave_type_id) : null}/>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-2 col-md-3 col-6 '>
                                                            <div><label>Apply Filter</label></div>
                                                            {/* <button type="button" onClick={this.handleFilter} className={` btn btn-info btn-label waves-effect waves-light ${(!this.state.employee_leave_status && !this.state.month && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}>
                                                                <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                                Filter
                                                            </button> */}
                                                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleFilter()})}} 
                                                            disabled={!this.state.employee_leave_status && !this.state.month && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id}
                                                            loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                                            buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                                        </div>
                                                        <div className='col-lg-2 col-md-3 col-6 '>
                                                            <div><label>Clear Filter</label></div>
                                                            {/* <button type="button"
                                                                className={`w-100 btn btn-secondary btn-label waves-effect waves-light noWrap ${(!this.state.employee_leave_status && !this.state.month && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}
                                                                onClick={this.handleClearAll}
                                                            >
                                                                <i className=" ri-database-2-line label-icon align-middle fs-16 me-2"></i> 
                                                                Clear
                                                            </button> */}
                                                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                                            disabled={!this.state.employee_leave_status && !this.state.month && !this.state.from_date && !this.state.to_date && !this.state.filter_leave_type_id}
                                                            loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                                                            buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                                        </div>
                                                        { this.state.decodedData?.includes(6) && ( 
                                                        <div className='col-lg-2 col-md-3 col-6'>
                                                            <div>
                                                                <label>Export Excel</label>
                                                            </div>
                                                            {/* <button
                                                                type="button"
                                                                onClick={this.handleExcelDownload}
                                                                className={`${this.state.rows.length === 0 ? ('disabled') : ""} noWrap btn btn-success btn-label waves-effect waves-light`}>
                                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                                Export Excel
                                                            </button> */}
                                                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.handleExcelDownload() }} 
                                                            disabled={this.state.rows.length === 0}
                                                            buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                                        </div>)}


                                                    </div> :
                                                    <div className="row">
                                                        <div className='col-md-2 position-relative mb-5'>
                                                            <div><label>Year</label></div>
                                                            <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                                <Select onChange={(selectedOption) => this.handleSelectChange("year", selectedOption)}
                                                                options={this.state.yearsOptions}
                                                                placeholder="Select Year"
                                                                value={ this.state?.year ? this.state?.yearsOptions.find(option => option.value === this.state?.year) : null }/>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-2 position-relative mb-5'>
                                                            <div><label>Leave Type</label></div>
                                                            <div style={{ "zIndex": 9, "width": "90%" }} className='  position-absolute'>
                                                                <Select onChange={(selectedOption) => this.handleSelectChange("leaveType", selectedOption)}
                                                                options={this.state.yearlyReport ? this.state?.leave_type_row?.filter((val) => this.state.LeaveRows?.some((leave) => leave.leave_type_id == val.value)): this.state?.leave_type_row}
                                                                placeholder="Select Leave"
                                                                value={this.state?.leaveType ? this.state?.leave_type_row.find(option => option.value === this.state?.leaveType) : ""}
                                                                isDisabled={!this.state?.year}/>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-2 col-md-3 col-6'>
                                                            <div><label>Apply Filter</label></div>
                                                            {/* <button
                                                                type="button"
                                                                onClick={this.getYearlyList}
                                                                className={`w-100 btn btn-info btn-label waves-effect waves-light ${(localStorage.getItem("employee_id_emp") && this.state?.year && this.state?.leaveType) ? '' : 'disabled'}`}>
                                                                <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                                Filter
                                                            </button> */}
                                                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.getYearlyList()})}} 
                                                            disabled={!localStorage.getItem("employee_id_emp") && !this.state?.year && !this.state?.leaveType}
                                                            loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                                            buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                                        </div>
                                                        <div className='col-lg-2 col-md-3 col-6'>
                                                            <div><label>Clear Filter</label></div>
                                                            {/* <button
                                                                type="button"
                                                                className={`btn btn-secondary btn-label waves-effect waves-light noWrap ${(localStorage.getItem("employee_id_emp") && this.state?.year && this.state?.leaveType) ? '' : 'disabled'}`}
                                                                onClick={this.handleClearAll}
                                                            >
                                                                <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 "></i> 
                                                                Clear
                                                            </button> */}
                                                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                                            disabled={!localStorage.getItem("employee_id_emp") && !this.state?.year && !this.state?.leaveType}
                                                            loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                                                            buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                                        </div>
                                                        { this.state.decodedData?.includes(6) && ( 
                                                        <div className='col-lg-2 col-md-3 col-6'>
                                                            <div><label>Export Excel</label></div>
                                                            {/* <button
                                                                type="button"
                                                                onClick={this.handleYearlyReportDownload}
                                                                className={`${this.state.leavesBalance?.length === 0 ? ('disabled') : ""} noWrap btn btn-success btn-label waves-effect waves-light`}>
                                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                                Export Excel
                                                            </button> */}
                                                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.handleYearlyReportDownload() }} 
                                                            disabled={this.state.leavesBalance?.length === 0}
                                                            buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                                        </div>)}
                                                    </div>
                                                }



                                            </div>
                                            {/* <div className=' col-md-4 d-flex align-items-center gap-3'>
                                                <div>
                                                    <div>
                                                        <label>Apply Filter</label>
                                                    </div>
                                                    <button type="button" onClick={this.handleFilter} className={` btn btn-info btn-label waves-effect waves-light ${(!this.state.employee_leave_status && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}>
                                                        <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                        Filter
                                                    </button>
                                                </div>
                                                <div>
                                                    <div>
                                                        <label>Clear Filter</label>
                                                    </div>
                                                    <button type="button"
                                                        className={`w-100 btn btn-secondary btn-label waves-effect waves-light noWrap ${(!this.state.employee_leave_status && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}
                                                        onClick={this.handleClearAll}
                                                    >
                                                        <i className=" ri-database-2-line label-icon align-middle fs-16 me-2"></i> Clear

                                                    </button>
                                                </div>
                                                <div className=''>
                                                    <div>
                                                        <label>Export Excel</label>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={this.handleExcelDownload}
                                                        className={`${this.state.rows.length === 0 ? ('disabled') : ""} noWrap btn btn-info btn-label waves-effect waves-light`}>
                                                        <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                        Export Excel
                                                    </button>
                                                </div>

                                            </div> */}
                                        </div>
                                        <div>

                                            <div className="col-lg-12 mt-4">
                                                <div className='card '>
                                                    <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                        {!this.state.yearlyReport ?
                                                            <table style={{ minWidth: '100%' }} className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                                <thead className="bg-primary text-center text-light bg-gradient sticky-top z-1">
                                                                    <tr>
                                                                        <th className=' noWrap'>Application Date</th>
                                                                        {/* <th className=' noWrap'>Action By</th> */}
                                                                        <th className=' noWrap'>Leave Type</th>
                                                                        <th className=' noWrap'>From Date</th>
                                                                        <th className=' noWrap'>To Date</th>
                                                                        <th>Before Balance</th>
                                                                        <th className=' noWrap'>Total Leave Days</th>
                                                                        <th>After Balance</th>
                                                                        <th>Reason</th>
                                                                        {/* <th>Remark</th> */}
                                                                        <th>Status</th>
                                                                        
                                                                { (this.state.decodedData?.includes(1)||this.state.decodedData?.includes(3))  && ( 
                                                                        <th>Action</th>)}
                                                                    </tr>
                                                                </thead>
                                                                {this.state.rows?.length === 0 ?
                                                                    <tbody>
                                                                        <tr>
                                                                            <td colSpan={11}>
                                                                                <NoRecords />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody> :
                                                                    <tbody className=' text-center'>
                                                                        {this.state.rows?.map((row) => {
                                                                            return (
                                                                                <tr key={row?.employee_leave_log_id}>
                                                                                    <td className=' noWrap'>{formatDate(row?.created_date)}</td>
                                                                                    {/* <td className=' noWrap'>{row.created_by_name}</td> */}
                                                                                    <td className=' noWrap'>{row?.heads_labels[0].concatenated_data}</td>
                                                                                    <td className=' noWrap'>{formatDate(row?.employee_leave_from_date)}</td>
                                                                                    <td className=' noWrap'>{formatDate(row?.employee_leave_to_date)}</td>
                                                                                    <td>{row?.employee_leave_balance_before || "--"}</td>
                                                                                    <td>{row?.employee_leave_days} {row.employee_leave_days <= 1 ? " day" : " days"}</td>
                                                                                    <td>{row?.employee_leave_balance_after || "--"}</td>
                                                                                    <td style={{ textAlign: "left" }} className={` ${row?.employee_leave_reason?.length >= 30 ? "textEllipse" : "noWrap"}`} >{row?.employee_leave_reason}</td>
                                                                                    {/* <td><div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: "200px" }}>{row.remark}</div></td> */}
                                                                                    <td ><span className={`badge bg-${row?.employee_leave_status_class}`}>{row?.employee_leave_status_label}</span></td>
                                                                                    { (this.state.decodedData?.includes(1)||this.state.decodedData?.includes(3))  && ( 
                                                                                    <td>
                                                                                        <div className="d-flex justify-content-center gap-1 align-items-center">
                                                                                        { this.state.decodedData?.includes(1)  && ( 
                                                                                            <button className="btn btn-outline-info btn-sm me-2" onClick={() => {  this.handleCheckModalType(2, row.employee_leave_id)}}>
                                                                                                {/* <i className='ri-eye-line' style={{ marginTop: "5px", marginRight: "5px" }} />  */}
                                                                                                View
                                                                                            </button>)}

                                                                                            {row.employee_leave_status === 0 ? (
                                                                                                this.state.decodedData?.includes(3)  && ( 
                                                                                                <button className="btn btn-outline-danger btn-sm" onClick={() => this.handleCancelLeave(row.employee_leave_id)}>
                                                                                                    {/* <i className='ri-close-fill' style={{ marginTop: "5px" }} />  */}
                                                                                                    Cancel
                                                                                                </button>)
                                                                                            ) : null}
                                                                                        </div>

                                                                                    </td>)}
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                    </tbody>
                                                                }
                                                            </table> :
                                                            <table style={{ width: '100%', }} className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                                <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                                    <tr>
                                                                        <th className=' noWrap'>Sr. No.</th>
                                                                        <th className=' noWrap'>Month</th>
                                                                        <th className=' noWrap'>Opening Balance</th>
                                                                        <th className=' noWrap'>Leave Accrued</th>
                                                                        <th className=' noWrap'>Leaves Taken</th>
                                                                        <th className=' noWrap'>Closing Balance</th>
                                                                    </tr>
                                                                </thead>
                                                                {this.state.leavesBalance?.length === 0 ?
                                                                    <tbody>
                                                                        <tr>
                                                                            <td colSpan={11}>
                                                                                <NoRecords />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody> :
                                                                    <tbody className=' text-center'>
                                                                        {this.state.leavesBalance?.map((row, idx) => {
                                                                            // console.log(row?.year);
                                                                            return (
                                                                                <tr>
                                                                                    <td>{idx + 1}</td>
                                                                                    <td>{monthData[parseInt(row?.month)]}-{row?.year}</td>
                                                                                    <td>{row?.opening_balance || '---'}</td>
                                                                                    <td>{row?.leave_accrued || '---'}</td>
                                                                                    <td>{row?.leave_taken || '---'}</td>
                                                                                    {/* { (this.state.decodedData?.includes(1)||this.state.decodedData?.includes(3)) && (  */}
                                                                                    <td>{row?.closing_balance || '---'}</td>
                                                                                    {/* )} */}
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                    </tbody>}

                                                            </table>
                                                        }

                                                    </div>
                                                    <div className=" bg-light d-flex justify-content-between align-items-center w-100 p-2 flex-wrap">
                                                    <button onClick={() => this.handlePrev()}
                                                    type="button"
                                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                                    disabled={ this.state.prev === false && this.state.loadingList === false }>
                                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                        Previous
                                                    </button>
                                                    <button disabled={ this.state.next === false && this.state.loadingList === false ? true : false }
                                                    type="button" onClick={() => this.handleNext()}
                                                    className={` d-md-none d-block btn btn-primary btn-label waves-effect right waves-light`}>
                                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                        Next
                                                    </button>
                                                    <div
                                                        className="col-md-4"
                                                        style={{ display: "flex", alignItems: "center" }}
                                                    >
                                                        {
                                                            <small>
                                                                Total Records: {this.state.total_records} |
                                                                Total Pages: {this.state.total_pages} |
                                                                Current Page: {this.state.page}
                                                            </small>
                                                        }
                                                    </div>
                                                    <div className="col-md-2">
                                                        <select
                                                            className="form-select"
                                                            onChange={(e) => this.handleChange(e)}
                                                        >
                                                            {Array.from(
                                                                { length: this.state.total_pages },
                                                                (_, i) => (
                                                                    <option
                                                                        selected={this.state.page === i + 1}
                                                                        key={i}
                                                                        value={i + 1}
                                                                    >
                                                                        Page {i + 1}
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                            {limitOptions.map((option) => (
                                                                <option key={option} value={option}>
                                                                    Limit {option}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <button disabled={ this.state.next === false && this.state.loadingList === false ? true : false }
                                                    type="button" onClick={() => this.handleNext()}
                                                    className={` d-md-block d-none btn btn-primary btn-label waves-effect right waves-light`}>
                                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                        Next
                                                    </button>
                                                </div>
                                                    {/* <div className="d-flex justify-content-between align-items-center w-100 py-2 px-2" >
                                                        <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                            {
                                                                <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                            }
                                                        </div>
                                                        <div className='col-md-2'>
                                                            <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                    <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                                {limitOptions.map((option) => (
                                                                    <option key={option} value={option}>
                                                                        Limit {option}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-lg-12 mt-4">
                                                <div className='card '>
                                                    <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                        <table style={{ width: '110%', minWidth: '1200px' }} className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                            <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th className=' noWrap'>Action Date</th>
                                                                        <th className=' noWrap'>Action By</th>
                                                                        <th className=' noWrap'>Leave Type</th>
                                                                        <th className=' noWrap'>From Date</th>
                                                                        <th className=' noWrap'>To Date</th>
                                                                        <th className=' noWrap'>Total Leave Days</th>
                                                                        <th>Reason</th>
                                                                        <th>Remark</th>
                                                                        <th>Status</th>
                                                                    </tr>
                                                                </thead>
                                                            </thead>
                                                            {this.state.rows.length === 0 ? (
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan={9}>
                                                                            <NoRecords />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            ) : (
                                                                <tbody>
                                                                    {leave_log_rows.map((row) => {
                                                                        var leave_obj = JSON.parse(row.leave_apply_object);
                                                                        return (
                                                                            <tr key={row.employee_leave_log_id}>
                                                                                <td>{formatDate(row.created_date)}</td>
                                                                                <td>{row.created_by_name}</td>
                                                                                <td>{leave_obj.leave_type_name}</td>
                                                                                <td>{formatDate(leave_obj.employee_leave_from_date)}</td>
                                                                                <td>{formatDate(leave_obj.employee_leave_to_date)}</td>
                                                                                <td>{leave_obj.employee_leave_days}</td>
                                                                                <td><div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: "200px" }}>{leave_obj.employee_leave_reason}</div></td>
                                                                                <td><div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: "200px" }}>{row.remark}</div></td>
                                                                                <td ><span className={`badge bg-${row.employee_leave_log_status_class}`}>{row.employee_leave_status_label}</span></td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                </tbody>)
                                                            }
                                                        </table>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center w-100 py-2 px-2" >
                                                        <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                            {
                                                                <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                            }
                                                        </div>
                                                        <div className='col-md-2'>
                                                            <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                    <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                                {limitOptions.map((option) => (
                                                                    <option key={option} value={option}>
                                                                        Limit {option}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                    </div>
                                                </div>
                                            </div> */}
                                    {/* </div> */}
                                </div>
                            </div>
                        </div >
                    </div >) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
        );
    }
}
export default MyLeavesSandBox;